import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'adpkd-acknowledgements',
  templateUrl: './acknowledgements.component.html',
  styleUrls: ['./acknowledgements.component.scss']
})
export class AcknowledgementsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
